import { err, ok } from "neverthrow";
import {
    useGetCompaniesQuery, 
    useCreateCompanyMutation, 
    useUpdateCompanyMutation, 
    useDeleteCompanyMutation, 
    useUpdateCompanyStatusMutation
} from "../services/companyService";
import type { 
    CreateCompanyPayload, 
    CreateCompanyResult, 
    DeleteCompanyResult, 
    UpdateCompanyEstatusPayload, 
    UpdateCompanyPayload, 
    UpdateCompanyResult,
} from "../types/company";

const useCompany = () => {
    const {data: companies, isLoading: isLoadingCompanies} = useGetCompaniesQuery()
    const [executeCreate, {isLoading: isLoadingCreateCompany}] = useCreateCompanyMutation()
    const [executeUpdate, {isLoading: isLoadingUpdateCompany}] = useUpdateCompanyMutation()
    const [executeDelete, {isLoading: isLoadingDeleteCompany}] = useDeleteCompanyMutation()
    const [executeUpdateStatus, {isLoading: isLoadingUpdateCompanyStatus}] = useUpdateCompanyStatusMutation();

    const createCompany = async (body: CreateCompanyPayload): CreateCompanyResult => {
        return await executeCreate(body)
        .unwrap()
        .then(() => ok(true))
        .catch((error) => err(error))
    }

    const updateCompany = async (body: UpdateCompanyPayload): UpdateCompanyResult => {
        return await executeUpdate(body)
        .unwrap()
        .then(() => ok(true))
        .catch((error) => err(error))
    }

    const updateCompanyStatus = async (body: UpdateCompanyEstatusPayload): UpdateCompanyResult => {
        return await executeUpdateStatus(body)
        .unwrap()
        .then(() => ok(true))
        .catch((error) => err(error))
    }

    const deleteCompany = async (id: number): DeleteCompanyResult => {
        return await executeDelete(id)
        .unwrap()
        .then(() => ok(true))
        .catch((error) => err(error))
    }

    return {
        companies,
        isLoadingCompanies,
        isLoadingCreateCompany,
        isLoadingUpdateCompany,
        isLoadingDeleteCompany,
        isLoadingUpdateCompanyStatus,
        createCompany,
        updateCompany,
        deleteCompany,
        updateCompanyStatus
    }
}

export default useCompany;